import request from './request'
import * as http from '@/libs/http'

/**
 * ステーション情報を取得する
 *
 * @param {String} orgcode 組織コード
 * @param {Number} stid ステーションID
 * @param {Array} fields 追加フィールド
 * @returns {Response} レスポンスデータ
 */
export function getStation (orgcode, stid, fields = []) {
  return request.get(`/org/${orgcode}/stations/${stid}`, {
    params: {
      fields: [
        'stationID',
        'shopID',
        ...fields
      ]
    },
    validateStatus: (status) => [
      http.OK,
      http.NotFound
    ].includes(status)
  })
}
